import React, { Component } from 'react'
import WebRTCAdaptor from '../../utils/webRTC'
import { connect } from 'react-redux'
import { openSnackBar } from 'actions/snack-bar'
import { Fab } from '@material-ui/core'
import { Camera } from '@material-ui/icons'
import { Fragment } from 'react'
import MediaControls from './mediaControls'

const defaultState = {
  token: 'null',
  videoHeight: window.innerHeight,
  audioOptions: [],
  videoOptions: [],
  dialogOpen: false
}

class Streamer extends Component {
  componentDidMount() {
    var pcConfig = null

    var sdpConstraints = {
      OfferToReceiveAudio: false,
      OfferToReceiveVideo: false
    }

    var mediaConstraints = {
      // video: {
      //   width: { ideal: 4096 },
      //   height: { ideal: 2160 }
      // },
      video: true,
      audio: true
    }

    var websocketURL = 'wss://live.event.gives/WebRTCAppEE/websocket'

    const helperCallback = (info, obj) => {
      console.log(info)
      console.log(obj)
      console.log('callback')
      if (info === 'initialized') {
        console.log('initialized')
      } else if (info === 'publish_started') {
        //stream is being published
        console.log('publish started')
      } else if (info === 'publish_finished') {
        //stream is being finished
        this.props.onFinish(obj)
        console.log('publish finished')
      } else if (info === 'closed') {
        //console.log("Connection closed");
        if (typeof obj !== 'undefined') {
          console.log('Connecton closed: ' + JSON.stringify(obj))
        }
      } else if (info === 'pong') {
        //ping/pong message are sent to and received from server to make the connection alive all the time
        //It's especially useful when load balancer or firewalls close the websocket connection due to inactivity
      } else if (info === 'refreshConnection') {
        console.log(this)
        this.startPublishing()
      } else if (info === 'updated_stats') {
        //obj is the PeerStats which has fields
        //averageOutgoingBitrate - kbits/sec
        //currentOutgoingBitrate - kbits/sec
        console.log(
          'Average outgoing bitrate ' +
            obj.averageOutgoingBitrate +
            ' kbits/sec' +
            ' Current outgoing bitrate: ' +
            obj.currentOutgoingBitrate +
            ' kbits/sec'
        )
      } else if (info === 'available_devices') {
        const audioOptions = obj.filter(x => x.kind === 'audioinput')
        const videoOptions = obj.filter(x => x.kind === 'videoinput')
        audioOptions[0].isActive = true
        videoOptions[0].isActive = true
        this.setState({ audioOptions, videoOptions })
      }
    }

    try {
      this.webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: websocketURL,
        mediaConstraints: mediaConstraints,
        peerconnection_config: pcConfig,
        sdp_constraints: sdpConstraints,
        localVideoId: 'localVideo',
        debug: true,
        callback: helperCallback,
        callbackError: function(error, message) {
          //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
          // console.trace(error)
          console.log('error callback: ' + JSON.stringify(error))
          var errorMessage = JSON.stringify(error)
          if (typeof message !== 'undefined') {
            errorMessage = message
          }
          if (error.indexOf('NotFoundError') !== -1) {
            errorMessage =
              'Camera or Mic are not found or not allowed in your device'
          } else if (
            error.indexOf('NotReadableError') !== -1 ||
            error.indexOf('TrackStartError') !== -1
          ) {
            errorMessage =
              'Camera or Mic is being used by some other process that does not let read the devices'
          } else if (
            error.indexOf('OverconstrainedError') !== -1 ||
            error.indexOf('ConstraintNotSatisfiedError') !== -1
          ) {
            errorMessage =
              'There is no device found that fits your video and audio constraints. You may change video and audio constraints'
          } else if (
            error.indexOf('NotAllowedError') !== -1 ||
            error.indexOf('PermissionDeniedError') !== -1
          ) {
            errorMessage = 'You are not allowed to access camera and mic.'
          } else if (error.indexOf('TypeError') !== -1) {
            errorMessage = 'Video/Audio is required'
          }

          console.error(errorMessage)
        }
      })
    } catch (err) {
      console.log(err)
      this.props.dispatch(
        openSnackBar({ message: 'Error starting your stream' })
      )
    }
    this.props.useRef(this)

    // fix root scroll style
    // document.getElementById('root').style.overflow = 'scroll'
  }

  webRTCAdaptor = null
  state = defaultState

  getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1))
    var sURLVariables = sPageURL.split('&')
    var sParameterName
    var i

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=')

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1]
      }
    }
  }

  createUUID() {
    return `${this.props.event.auction_code}-${
      this.props.authenticatedUser.user_id
    }-${new Date().getTime()}`
  }

  startPublishing() {
    const { token } = this.state
    const uuid = this.createUUID()
    try {
      this.webRTCAdaptor.publish(uuid, token)
    } catch (err) {
      console.log(err)
      this.props.dispatch(
        openSnackBar({ message: 'Error starting your stream' })
      )
    }
    this.props.onPublish(uuid)
  }

  handleClose = () => {
    this.setState({ dialogOpen: false })
  }

  // stopPublishing() {
  //   const { streamId } = this.state
  //   try {
  //     this.webRTCAdaptor.stop(streamId)
  //   } catch (err) {
  //     this.props.dispatch(
  //       openSnackBar({ message: 'Error starting your stream' })
  //     )
  //     console.log(err)
  //   }
  // }

  // enableDesktopCapture(enable) {
  //   const { streamId } = this.state
  //   if (enable === true) {
  //     this.webRTCAdaptor.switchDesktopCapture(streamId)
  //   } else {
  //     this.webRTCAdaptor.switchVideoCapture(streamId)
  //   }
  // }

  render() {
    const { videoHeight } = this.state
    const { streamName } = this.props
    const be100 = this.props.be100
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
    const isIOS = /iPhone|iPod|iPad/i.test(navigator.userAgent)
    // console.log(this.state.streamId)
    return (
      <Fragment>
        <div
          className="container"
          style={{
            position: 'absolute',
            top: 0,
            maxWidth: be100 ? '100%' : 'calc(100vw - 200px)',
            left: '50%',
            transform: 'translate(-50%)',
            width: '100%'
          }}
        >
          <div
            className="jumbotron"
            style={{
              margin: 0,
              position: 'relative',
              width: '100%',
              paddingTop: '56.25%',
              overflow: 'hidden'
            }}
          >
            <video
              id="localVideo"
              autoPlay
              muted
              // height={videoHeight}
              style={{
                // left: '50%',
                // transform: 'translate(-50%)',
                // height: '100vh',
                top: 0,
                left: 0,
                width: '100%',
                position: 'absolute',
                transition: 'filter 1000ms',
                filter: streamName
                  ? 'blur(0px) contrast(1)'
                  : 'blur(20px) contrast(1.5)'
              }}
              playsInline="playsinline"
            />
          </div>
        </div>
        {!isIOS || (isIOS && !isMobile) ? (
          <Fragment>
            <Fab
              style={{
                position: 'fixed',
                bottom: '16px',
                right: '16px',
                zIndex: 10
              }}
              onClick={() => this.setState({ dialogOpen: true })}
            >
              <Camera />
            </Fab>
            <MediaControls
              open={this.state.dialogOpen}
              handleClose={this.handleClose}
              audioOptions={this.state.audioOptions}
              videoOptions={this.state.videoOptions}
              webRTCAdaptor={this.webRTCAdaptor}
              streamUUID={this.props.streamUUID}
              setState={e => this.setState(e)}
            />
          </Fragment>
        ) : null}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    event: state.event.event
  }
}

const connector = connect(mapStateToProps)

export default connector(Streamer)



// WEBPACK FOOTER //
// ./src/components/Streamer/index.jsx